import { Stack } from "@mui/material";
import { FieldArrayWithId } from "react-hook-form";
import withDraggable from "hocs/withDraggable";
import { QuestionInputs } from "pages/Question/view/types";
import CheckboxItem from "./CheckboxItem";

const CheckboxItemWithDraggable = withDraggable(CheckboxItem);

interface CheckboxesListProps {
  fields: FieldArrayWithId<QuestionInputs, "partsInput", "formId">[];
  removeCheckbox: (index: number) => void;
  isEditing: boolean;
}

const CheckboxesList = ({ fields, removeCheckbox, isEditing }: CheckboxesListProps) => {
  return (
    <Stack spacing={2}>
      {fields.map((field, index) => (
        <CheckboxItemWithDraggable
          key={`multiple-answer-${field.formId}`}
          draggableId={field.formId}
          isDragDisabled={!isEditing}
          index={index}
          element={field}
          removeCheckbox={removeCheckbox}
          isEditing={isEditing}
        />
      ))}
    </Stack>
  );
};

export default CheckboxesList;
